import axios from '@/utils/http';

export default (notice, status) => {
  return axios
    .put(`/advertisement_notice/${notice}/change_status`, { status })
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};
